import DescriptionIcon from "@mui/icons-material/Description";
import HandshakeIcon from "@mui/icons-material/Handshake";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

export function toolCallIcon(toolName: string | undefined) {
    switch (toolName) {
        case "search_documents":
            return <DescriptionIcon />;
        case "query_contracts":
            return <HandshakeIcon />;
        default:
            return <AutoAwesomeIcon />;
    }
}
